(function($) {

    /** A really simple plugin to disable a link once clicked. To stop users hamering away at long running tasks.
     * Could possibly be removed when we add the servet filter to do this
     */

    $.fn.disableLinkOnClick = function() {

        return this.each(function(){
                  $(this).click(function()
                  {
                      $(this).click(function(){return false});
                  });
        })
    };
        
})(jQuery);